var map = {
	"./en/common.json": 8419,
	"./en/home.json": 65833,
	"./fa/aboutUs.json": 80587,
	"./fa/app.json": 66089,
	"./fa/auth.json": 40874,
	"./fa/cart.json": 91122,
	"./fa/common.json": 53041,
	"./fa/contact-us.json": 66791,
	"./fa/course.json": 89813,
	"./fa/directPayment.json": 64559,
	"./fa/exam.json": 60863,
	"./fa/explore.json": 79193,
	"./fa/faq.json": 6598,
	"./fa/form.json": 88826,
	"./fa/home.json": 70323,
	"./fa/howToLearn.json": 61703,
	"./fa/instructors.json": 27974,
	"./fa/jobs.json": 85104,
	"./fa/landing.json": 38625,
	"./fa/leaderboard.json": 73833,
	"./fa/new-explore.json": 97326,
	"./fa/non-domestic-payment.json": 5873,
	"./fa/organization.json": 46743,
	"./fa/privacyPolicy.json": 72148,
	"./fa/program.json": 72870,
	"./fa/recentlyViewed.json": 31868,
	"./fa/recommendedCourse.json": 59836,
	"./fa/school.json": 16812,
	"./fa/search.json": 93308,
	"./fa/socialNetworks.json": 25244,
	"./fa/special-offers.json": 93165,
	"./fa/subscription.json": 44233,
	"./fa/teaching.json": 93451,
	"./fa/terms.json": 97297,
	"./fa/university.json": 86668,
	"./fa/user.json": 26639
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64519;
module.exports = webpackAsyncContext;